import {
    RaikoGridOneColumn,
    RaikoMaterialOutlinedInput,
    RaikoSimpleMultiLineInputOutlined,
    RaikoButtonPrimary,
    RaikoFlexAlignEnd,
    showErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components"
import {css} from "@emotion/css";
import {useState} from "react";
import {FeaturesService} from "../../serverService/featuresService/FeaturesService";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";


export default function AddNewFeature({handlePushNewFeatureToTable}) {


    const [title, setTitle] = useState("")
    const [description, setDescription] = useState("")
    const [buttonLoading, setButtonLoading] = useState(false)

    const service = new FeaturesService()

    function handleAddNewFeature() {
        setButtonLoading(true)
        service.addNewFeature(title, description).then(
            response => {
                showSuccessMessage("ویژگی جدید با موفقیت افزوه شد.")
                handlePushNewFeatureToTable(response)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setButtonLoading(false)
        })
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoMaterialOutlinedInput
                labelText={"عنوان"}
                value={title}
                setValue={setTitle}
            />
            <RaikoSimpleMultiLineInputOutlined
                labelText={"توضیحات"}
                value={description}
                setValue={setDescription}
            />
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary onClick={handleAddNewFeature} label={"افزودن"} loading={buttonLoading}/>
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}